import { View } from '@24i/nxg-sdk-quarks';

export default View;
